module.exports = __webpack_public_path__ + "img/icon1.e0577858.svg";